// Copyright (c) 2016 Deere & Company

import CustomerSummary, {getDefaultState as getCustomerSummaryDefaultState} from './customer-summary';
import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import t from 'tcomb';

const PipProduct = t.struct({
    baseMachineCode: t.String,
    comments: t.String,
    completedDate: t.maybe(t.Number),
    customerSummary: CustomerSummary,
    daysRemaining: t.Number,
    description: t.String,
    dtac: t.String,
    dtacUrl: t.String,
    excludedPin: t.String,
    expireDate: t.maybe(t.Number),
    id: t.String,
    internalRecall: t.String,
    leadAccount: Dealer,
    metric: KeyValuePair,
    model: t.String,
    participant: KeyValuePair,
    pin: t.String,
    pipCode: t.String,
    pipCompletionStatus: KeyValuePair,
    pipFilter: KeyValuePair,
    pipId: t.String,
    pipNumber: t.String,
    pipStatus: KeyValuePair,
    pipType: KeyValuePair,
    responsibleAccount: Dealer,
    startDate: t.maybe(t.Number),
    statusReason: t.String,
    terminationDate: t.maybe(t.Number)
}, {
    name: 'PipProduct',
    strict: true
});

export const getDefaultState = () => new PipProduct({
    baseMachineCode: '',
    comments: '',
    completedDate: null,
    customerSummary: getCustomerSummaryDefaultState(),
    daysRemaining: 0,
    description: '',
    dtac: '',
    dtacUrl: '',
    excludedPin: '',
    expireDate: null,
    id: '',
    internalRecall: '',
    leadAccount: getDealerDefaultState(),
    metric: getKeyValuePairDefaultState(),
    model: '',
    participant: getKeyValuePairDefaultState(),
    pin: '',
    pipCode: '',
    pipCompletionStatus: getKeyValuePairDefaultState(),
    pipFilter: getKeyValuePairDefaultState(),
    pipId: '',
    pipNumber: '',
    pipStatus: getKeyValuePairDefaultState(),
    pipType: getKeyValuePairDefaultState(),
    responsibleAccount: getDealerDefaultState(),
    startDate: null,
    statusReason: '',
    terminationDate: null
});

export default PipProduct;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/pip-product.js